/**
 * Calendar integration domain — cache invalidation registry.
 *
 * Mutations:
 *   - `selectCalendar` — flips `is_selected` on a Calendar row, so only
 *     the per-integration calendar list must refetch. Events aren't
 *     touched, so we don't bust that cache.
 *   - `syncCalendar` — enqueues a background Celery task that returns
 *     immediately. New events only land after the worker finishes, so
 *     any refetch fired on mutation success races the worker and pulls
 *     stale data. Leave invalidation empty until the API gains a
 *     completion signal (job id + polling, or websocket push). See the
 *     follow-up ticket linked in the PR description.
 */

import { type InvalidationRule } from '../invalidation/useInvalidatingMutation'
import { listCalendarsQueryKey } from '../generated/hooks/calendarIntegrationController'

export type CalendarIntegrationMutationId = 'selectCalendar' | 'syncCalendar'

export const invalidationRegistry: Record<
  CalendarIntegrationMutationId,
  InvalidationRule<any>
> = {
  selectCalendar: {
    invalidates: (variables: { integration_id: number }) => [
      listCalendarsQueryKey({ integration_id: variables.integration_id }),
    ],
  },
  syncCalendar: {
    invalidates: () => [],
  },
}
